<template>
  <div
    class="ElevatorArchives ashComWrap"
    v-loading="$store.state.user.loadingState"
  >
    <div class="comTitle">
      <h4>电梯档案</h4>
      <div v-if="authority">
        <el-button size="mini" v-if="!showEdit" @click="showEdit = true"
          >编辑</el-button
        >
        <template v-else>
          <el-button size="mini" @click="cancellation">取消</el-button>
          <el-button type="primary" size="mini" @click="saveBtn"
            >保存</el-button
          >
        </template>
      </div>
    </div>
    <div class="comContentBox filesContent">
      <el-form
        ref="form"
        :model="form"
        label-width="110px"
        label-position="left"
        size="mini"
      >
        <el-form-item label="设备ID">
          <p>{{ elevatorinfo.id }}</p>
        </el-form-item>
        <el-form-item label="所在位置">
          <p>{{ elevatorinfo.location }}</p>
        </el-form-item>
        <el-form-item label="管理单位">
          <p>{{ elevatorinfo.managementUnit }}</p>
        </el-form-item>
        <el-form-item label="管理员">
          <el-select v-if="showEdit" v-model="form.user" value-key="id">
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </el-select>
          <p v-else>{{ form.user.name }}</p>
        </el-form-item>
        <el-form-item label="联系电话">
          <p>{{ form.user.phone }}</p>
        </el-form-item>
        <el-form-item label="品牌">
          <p>{{ elevatorinfo.brand }}</p>
        </el-form-item>
        <el-form-item label="型号">
          <p>{{ elevatorinfo.model }}</p>
        </el-form-item>
        <el-form-item label="设备类型">
          <p>{{ elevatorinfo.type }}</p>
        </el-form-item>
        <el-form-item label="额定载重">
          <p>{{ elevatorinfo.ratedLoad }}kg</p>
        </el-form-item>
        <template v-if="activeTree.type == '直梯'">
          <el-form-item label="定员">
            <p>{{ elevatorinfo.personnelQuota }}人</p>
          </el-form-item>
          <el-form-item label="层站">
            <template v-if="showEdit">
              <el-input-number
                v-model="form.landing"
                :precision="0"
              ></el-input-number>
              <span>层</span>
            </template>
            <p v-else>{{ form.landing }}层</p>
          </el-form-item>
          <el-form-item label="最高速度">
            <p>{{ elevatorinfo.maximumSpeed }}m/s</p>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="载重速度">
            <p>{{ elevatorinfo.loadSpeed }}m/s</p>
          </el-form-item>
          <el-form-item label="节能速度">
            <p>{{ elevatorinfo.energySavingSpeed }}m/s</p>
          </el-form-item>
        </template>
        <el-form-item label="维保单位">
          <el-input v-if="showEdit" v-model.trim="form.unit"></el-input>
          <p v-else>{{ form.unit }}</p>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-if="showEdit" v-model.trim="form.phone"></el-input>
          <p v-else>{{ form.phone }}</p>
        </el-form-item>
        <el-form-item label="保养周期">
          <p>{{ elevatorinfo.serviceInterval }}天/次</p>
        </el-form-item>
        <el-form-item label="最近巡检时间">
          <p>{{ elevatorinfo.inspection }}</p>
        </el-form-item>
        <el-form-item label="最近维修时间">
          <p>{{ elevatorinfo.order }}</p>
        </el-form-item>
        <el-form-item label="最近保养时间">
          <p>{{ elevatorinfo.maintenance }}</p>
        </el-form-item>
        <el-form-item label="下次保养时间">
          <p>{{ elevatorinfo.nextMaintenanceTime }}</p>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-if="showEdit"
            v-model.trim="form.remark"
          ></el-input>
          <p v-else>{{ form.remark }}</p>
        </el-form-item>
        <el-form-item label="设备码">
          <div class="qrcode" ref="qrcode"></div>
        </el-form-item>
        <el-form-item label="设备文档">
          <ul>
            <li v-for="(v, i) in form.documentList" :key="i">
              <a style="color: #333" :href="v.imgUrl" :download="v.name">{{
                v.name
              }}</a>
              <el-button
                v-if="showEdit"
                style="margin-left: 5px"
                type="text"
                @click="deleteFile(v)"
                >删除</el-button
              >
            </li>
          </ul>
        </el-form-item>
        <template v-if="showEdit">
          <el-upload
            class="upload-demo"
            ref="upload"
            action="#"
            accept=".xlsx,.pdf,.doc,.docx,.xls,.rar,.zip"
            :on-change="onChange"
            :file-list="fileList"
            :auto-upload="false"
            style="margin-bottom: 10px"
          >
            <el-button slot="trigger" size="mini">点击添加文件上传</el-button>
          </el-upload>
        </template>
      </el-form>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import axios from "axios";
import QRCode from "qrcodejs2";
import {
  dateFtt,
  handleJudgmentNumbers,
  judgeAuthority,
} from "@/assets/js/utils";
import { handleExportAuthority } from "@/assets/utils/handleData.js";
export default {
  props: {
    activeTree: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      authority: false, //编辑权限
      showEdit: false,
      httpUrl: "",
      elevatorinfo: {},
      form: {
        name: "",
        user: {},
        remark: "",
        unit: "",
        phone: "",
        landing: 1, //层站
        documentList: [],
      },
      userList: [],
      qrcode: null,
      fileList: [],
    };
  },
  watch: {
    activeTree: {
      handler(newvalue, oldvalue) {
        if (this.activeTree.id) {
          this.showEdit = false;
          this.$nextTick(() => {
            document.getElementsByClassName("filesContent")[0].scrollTop = 0;
          });
          this.getElevatorArchives();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    deleteFile(item) {
      this.form.documentList = this.form.documentList.filter((v) => {
        return v.url !== item.url;
      });
    },
    async getElevatorArchives() {
      this.httpUrl = window.jujiParams.baseURL;
      let res = await api.DynamicalStateGetElevatorArchives({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceId: this.activeTree.id,
        deviceType: this.activeTree.type,
      });
      if (res && res.data.code == 200) {
        this.elevatorinfo = res.data.data;
        this.elevatorinfo.maintenance = handleJudgmentNumbers(
          this.elevatorinfo.maintenance
        )
          ? dateFtt(
              "yyyy-MM-dd hh:mm:ss",
              new Date(this.elevatorinfo.maintenance)
            )
          : this.elevatorinfo.maintenance;
        this.elevatorinfo.nextMaintenanceTime = handleJudgmentNumbers(
          this.elevatorinfo.nextMaintenanceTime
        )
          ? dateFtt(
              "yyyy-MM-dd",
              new Date(this.elevatorinfo.nextMaintenanceTime)
            )
          : this.elevatorinfo.nextMaintenanceTime;
        this.elevatorinfo.inspection = handleJudgmentNumbers(
          this.elevatorinfo.inspection
        )
          ? dateFtt(
              "yyyy-MM-dd hh:mm:ss",
              new Date(this.elevatorinfo.inspection)
            )
          : this.elevatorinfo.inspection;
        this.elevatorinfo.order = handleJudgmentNumbers(this.elevatorinfo.order)
          ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.elevatorinfo.order))
          : this.elevatorinfo.order;

        this.form.remark = this.elevatorinfo.remark;
        this.form.unit = this.elevatorinfo.maintenanceUnit;
        this.form.landing = this.elevatorinfo.landing;
        this.form.phone = this.elevatorinfo.telephone;
        this.form.user = this.elevatorinfo.administrators[0]
          ? this.elevatorinfo.administrators[0]
          : {};

        this.form.documentList = Array.from(this.elevatorinfo.documents).map(
          (v) => ({
            name: v.name,
            url: v.url,
            imgUrl: `${this.httpUrl}/${v.url}?tenant_id=${
              JSON.parse(window.sessionStorage.getItem("userInfo")).tenantId
            }`,
          })
        );
        this.$nextTick(() => {
          this.creatQrCode();
        });
      }
    },
    creatQrCode() {
      let text = `${this.httpUrl}?tenantId=${
        JSON.parse(window.sessionStorage.getItem("userInfo")).tenantId
      }&pointId=${this.elevatorinfo.id}&num=${this.elevatorinfo.qrCodeVersion}`;
      this.$refs.qrcode.innerHTML = "";
      this.qrcode = new QRCode(this.$refs.qrcode, {
        text: text,
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
      });
      this.qrcode._el.title = "";
    },
    cancellation() {
      this.form.remark = this.elevatorinfo.remark;
      this.form.unit = this.elevatorinfo.maintenanceUnit;
      this.form.landing = this.elevatorinfo.landing;
      this.form.phone = this.elevatorinfo.telephone;
      this.form.user = this.elevatorinfo.administrators[0]
        ? this.elevatorinfo.administrators[0]
        : {};
      this.form.documentList = Array.from(this.elevatorinfo.documents).map(
        (v) => ({
          name: v.name,
          url: v.url,
          imgUrl: `${this.httpUrl}/${v.url}?tenant_id=${
            JSON.parse(window.sessionStorage.getItem("userInfo")).tenantId
          }`,
        })
      );
      this.showEdit = false;
    },
    fileLists(param) {
      let userToken = window.sessionStorage.getItem("token");
      let fd = new FormData();
      fd.append("file", param);
      return new Promise((resolve) => {
        axios
          .post(this.httpUrl + "/api/juji/filesvc/upload", fd, {
            headers: {
              "Content-Type": "multipart/form-data",
              "X-Authorization": `Bearer ${userToken}`,
            },
          })
          .then((res) => {
            if (res && res.status == 200) {
              resolve(res.data);
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((err) => {});
      });
    },
    onChange(file, fileList) {
      this.fileList = fileList;
    },
    async submitFun() {
      let res = await api.DynamicalStateEditElevatorArchives({
        deviceId: this.elevatorinfo.id,
        administrators: [this.form.user],
        landing: this.form.landing,
        maximumSpeed: this.elevatorinfo.maximumSpeed,
        serviceInterval: this.elevatorinfo.serviceInterval,
        maintenanceUnit: this.form.unit,
        telephone: this.form.phone,
        remark: this.form.remark,
        documents: this.form.documentList,
      });
      if (res && res.data.code == 200) {
        this.$message.success("保存成功!");
        this.showEdit = false;
        this.getElevatorArchives();
        this.$store.commit("SET_LOADING", false);
      } else {
        this.showEdit = false;
        this.$store.commit("SET_LOADING", false);
      }
    },

    saveBtn() {
      this.$store.commit("SET_LOADING", true);
      if (this.fileList.length) {
        Promise.all(this.fileList.map((v) => this.fileLists(v.raw))).then(
          (res) => {
            res.map((v) => {
              this.form.documentList.push({
                name: v.name,
                url: v.uri,
              });
            });
            this.submitFun();
          }
        );
      } else {
        this.submitFun();
      }
    },
    async getUserList() {
      let res = await api.projectGetUserListByTenant({
        tenantIds: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .tenantId,
      });
      if (res && res.data.code == 200) {
        this.userList = Array.from(res.data.data).map((v) => ({
          id: v.userId,
          name: v.userName,
          phone: v.phone,
          department: v.department,
        }));
      }
    },
  },
  created() {
    this.authority = judgeAuthority(handleExportAuthority(this.$route.path));
    this.getUserList();
  },
};
</script>

<style lang="scss" scoped>
.ElevatorArchives {
  width: 100%;

  .filesContent {
    width: 93%;
    margin: 0 auto;
    // padding: 10px 0;
    overflow: auto;
    .qrcode {
      width: 100px;
      height: 100px;
    }
  }
}
</style>
